var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError500(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 273,
    viewBox: "0 0 272 273",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 75.9302H73.6406V90.1454H149.82V75.9302Z",
    fill: "#B0B6EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 115.299H73.6406V129.514H149.82V115.299Z",
    fill: "#B0B6EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 151.015H73.6406V165.23H149.82V151.015Z",
    fill: "#B0B6EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 190.384H73.6406V204.599H149.82V190.384Z",
    fill: "#B0B6EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M197.57 206.788H71.543V174.349H197.57V206.788ZM75.1891 203.142H193.924V177.995H75.1891V203.142Z",
    fill: "#23293F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M179.358 140.083H160.026V136.437H178.153C178.49 137.674 178.892 138.891 179.358 140.083Z",
    fill: "#23293F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.57 168.876H71.543V136.437H166.594V140.083H75.1891V165.23H193.924V161.591H197.57V168.876Z",
    fill: "#23293F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M197.569 160.496V161.591H193.923V158.34C195.089 159.13 196.306 159.849 197.569 160.496Z",
    fill: "#23293F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.496 98.5322C187.323 99.6785 186.222 100.896 185.199 102.178H167.318V98.5322H188.496Z",
    fill: "#23293F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.742 130.971H71.543V98.5322H173.524V102.178H75.1891V127.325H164.742V130.971Z",
    fill: "#23293F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M177.085 130.971H157.112V127.325H176.813C176.852 128.556 176.936 129.773 177.091 130.971H177.085Z",
    fill: "#23293F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M197.57 93.0662H71.543V60.627H197.57V93.0662ZM75.1891 89.4201H193.924V64.273H75.1891V89.4201Z",
    fill: "#23293F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 66.8184H146.174V86.778H149.82V66.8184Z",
    fill: "#23293F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 104.73H146.174V124.69H149.82V104.73Z",
    fill: "#23293F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 142.635H146.174V162.594H149.82V142.635Z",
    fill: "#23293F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.82 180.54H146.174V200.5H149.82V180.54Z",
    fill: "#23293F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.018 75.2046H174.242V78.8507H195.018V75.2046Z",
    fill: "#23293F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.267 154.661H174.242V151.015H185.789C186.871 152.304 188.036 153.521 189.267 154.661Z",
    fill: "#23293F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M195.018 188.927H174.242V192.573H195.018V188.927Z",
    fill: "#23293F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4276 134.98H22.4596C18.7229 134.98 15.6855 131.943 15.6855 128.206V109.464H41.2017V128.206C41.2017 131.943 38.1644 134.98 34.4276 134.98ZM19.3316 113.11V128.206C19.3316 129.929 20.737 131.334 22.4596 131.334H34.4276C36.1503 131.334 37.5556 129.929 37.5556 128.206V113.11H19.3316Z",
    fill: "#23293F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9527 101.083H21.3066V111.29H24.9527V101.083Z",
    fill: "#23293F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0982 101.446H32.4521V111.653H36.0982V101.446Z",
    fill: "#23293F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3688 184.549H50.8835C37.5037 184.549 26.6172 173.662 26.6172 160.282V136.8H30.2633V160.282C30.2633 171.655 39.5113 180.903 50.8835 180.903H73.3688V184.549Z",
    fill: "#23293F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3793 90.7469L8.59277 93.9253L17.0215 98.663L18.808 95.4846L10.3793 90.7469Z",
    fill: "#23293F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2598 90.0009L38.5137 94.7397L40.2506 97.9455L48.9967 93.2066L47.2598 90.0009Z",
    fill: "#23293F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2693 84.2796L26.624 84.3579L26.8719 95.9023L30.5171 95.824L30.2693 84.2796Z",
    fill: "#23293F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M248.232 126.594C248.232 133.251 246.225 139.449 242.779 144.591L231.64 133.452L234.82 121.574L221.978 108.732L213.604 110.979L226.446 123.815L225.507 127.312L223.992 132.986L217.101 134.838L214.822 135.453L201.979 122.611L199.732 130.978L212.574 143.82L223.234 140.971L234.794 152.531L235.008 152.744C229.626 156.695 222.988 159.033 215.8 159.033C197.88 159.033 183.36 144.513 183.36 126.594C183.36 108.674 197.88 94.1543 215.8 94.1543C233.719 94.1543 248.239 108.674 248.239 126.594H248.232Z",
    fill: "#B0B6EE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M250.615 167.853C248.627 167.853 246.755 167.076 245.344 165.671L222.683 143.011L212.03 145.86L197.698 131.528L201.027 119.088L215.359 133.419L222.496 131.502L224.406 124.366L210.074 110.034L222.515 106.705L236.847 121.037L233.667 132.908L255.887 155.128C257.299 156.533 258.069 158.405 258.069 160.399C258.069 162.394 257.292 164.259 255.887 165.671C254.475 167.083 252.603 167.853 250.609 167.853H250.615ZM223.778 138.944L247.928 163.093C248.646 163.812 249.605 164.207 250.622 164.207C251.638 164.207 252.597 163.812 253.322 163.093C254.041 162.374 254.436 161.416 254.436 160.399C254.436 159.382 254.041 158.43 253.322 157.705L229.613 133.996L232.793 122.125L221.44 110.772L217.133 111.925L228.486 123.278L225.481 134.481L214.277 137.486L202.925 126.134L201.772 130.44L213.125 141.793L223.778 138.944Z",
    fill: "#23293F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M215.735 160.58C196.941 160.58 181.65 145.29 181.65 126.496C181.65 107.702 196.941 92.4121 215.735 92.4121C234.528 92.4121 249.819 107.702 249.819 126.496C249.819 131.418 248.789 136.172 246.762 140.621L243.446 139.112C245.26 135.142 246.173 130.894 246.173 126.496C246.173 109.71 232.514 96.0582 215.735 96.0582C198.955 96.0582 185.296 109.716 185.296 126.496C185.296 143.276 198.955 156.934 215.735 156.934C220.669 156.934 225.378 155.788 229.723 153.534L231.4 156.772C226.595 159.266 221.175 160.58 215.728 160.58H215.735Z",
    fill: "#23293F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M233.654 203.142H201.15V206.788H233.654V203.142Z",
    fill: "#23293F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8214 203.142H39.3174V206.788H71.8214V203.142Z",
    fill: "#23293F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError500);
export default __webpack_public_path__ + "static/media/error500.1bb4a3bb729a9e3b99f95d48a6e4bfd4.svg";
export { ForwardRef as ReactComponent };